/**
 * 云服务类别 产品图表页 图表Item
 *
 * @format
 */

import React, { useRef, useImperativeHandle, forwardRef } from 'react'
import { _$ } from '@king-design/react'
import { echartTooltipOptions } from 'src/components/EchartReact/constants'
import { EchartReact } from 'src/components'
import { handleUnit, tooltipFormatter } from 'src/utils'
interface MonitorChartItemAppProps {
  xData: any[]
  series: any[]
  maxValue: number
  minValue: number
  interval: string
  units: string
  title?: string
}
export interface MonitorChartItemAppHandle {
  chartResize: () => void
}
const MonitorChartItemApp = forwardRef<MonitorChartItemAppHandle, MonitorChartItemAppProps>(
  ({ xData, series, interval, units }, ref) => {
    const chartRef = useRef(null)
    useImperativeHandle(ref, () => ({
      chartResize: () => {
        const chartInstance = chartRef.current?.getEchartsInstance()
        if (chartInstance) {
          chartInstance.resize()
        }
      }
    }))

    return (
      <EchartReact
        ref={chartRef}
        style={{ height: '100%', width: '100%' }}
        option={{
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xData
          },
          series: series,
          yAxis: {
            name: interval ? `${_$('周期')}:${interval}s` : '',
            nameTextStyle: {
              padding: [0, 0, 0, 40] // 名称与y轴的间距
            },
            type: 'value',
            splitNumber: 4,
            axisLine: {
              show: true
            },
            axisLabel: {
              margin: 5,
              formatter: function (value) {
                if (value === 0) {
                  return 0
                }
                const val = handleUnit(value, units, true)
                return val
              }
            }
          },
          tooltip: {
            ...echartTooltipOptions,
            formatter: function (params) {
              return tooltipFormatter(params, units)
            }
          },
          legend: {
            right: '10px',
            top: 0,
            type: 'scroll',
            width: '70%'
          }
        }}
      />
    )
  }
)
export default React.memo(MonitorChartItemApp)
